/* unplugin-vue-components disabled */import { render } from "./science_answer_m.vue?vue&type=template&id=31273e83&scoped=true"
import script from "./science_answer_m.vue?vue&type=script&lang=js"
export * from "./science_answer_m.vue?vue&type=script&lang=js"

import "./science_answer_m.vue?vue&type=style&index=0&id=31273e83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31273e83"]])

export default __exports__